import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase);

export const easeDefault = CustomEase.create("easeDefault", ".22,0,.31,1");

gsap.defaults({
    ease: easeDefault,
    duration: 1,
});

gsap.config({
    nullTargetWarn: true,
    autoSleep: 60,
    force3D: false,
});
